{
  "heatNumber":"Heat number",
  "grade":"Grade",
  "begin":"Início",
  "end":"Fim",
  "ladle":"Ladle",
  "weight":"Peso",
  "samples":"Amostras",
  "buckets":"Buckets",
  "alloys":"Ligas",
  "delays":"Demoras",
  "status":"Status",
  "temperature":"Temperatura",
  "tapToTapTemperature":"Temperatura TapToTap",
  "sourceName":"Fonte",
  "variables":"Variáveis"
}
